<template>
  <div class="bto-sb-widget bto-sb-widget-sportlist-menu">
    <div class="bto-sb-widget-title" :class="{ 'bto-sb-widget-title-icon': !isUS }">
      <span v-if="!isUS" class="bto-sb-widget-title-icon"></span>
      <h3>{{ t("mobile.allsports") }}</h3>
    </div>
    <div class="bto-sb-filter-slider-content" v-if="!onlySport">
      <range-slider-component
        :values="[
          'Public.Today',
          'SportMenu.24Filter',
          'SportMenu.3DaysFilter',
          'Public.Week',
          'Mobile.all',
        ]"
        :handlerFunction="onDateSliderChange"
        :invertValuesPosition="true"
        initialValue="Mobile.all" />
    </div>
    <div ref="fmenu">
      <div>
        <div class="bto-sb-widget-content">
          <ul>
            <li
              v-for="sport in sortByFavoriteSports"
              v-bind:key="sport.id"
              :class="{ 'bto-sb-sportlist-item-active': isSportActive(sport) }">
              <span
                class="bto-sb-sportlist-menu-item"
                @click="onlySport ? selectSport(sport) : toggleMenu(`s${sport.id}`, sport)">
                <span
                  class="bto-sb-sports-icon"
                  v-show="showSportIcon"
                  v-bind:class="sport.class"></span>
                <span
                  class="bto-sb-sportlist-menu-sport-name"
                  @click="sportSelectionGTM(sport.name)">
                  {{ sport.name }}
                </span>
                <ToggleFavoriteComponent v-if="showFavorites" :favType="1" :sport="sport" />
                <span
                  class="bto-sb-sportlist-menu-sport-events"
                  v-if="showOutrights === true && !onlySport">
                  {{ sport.numberOfItems }}
                </span>
                <span
                  class="bto-sb-sportlist-menu-sport-events"
                  v-else
                  v-show="showNumbers && !onlySport">
                  {{ sport.numberOfMarkets }}
                </span>
              </span>
              <ul
                class="bto-sb-sportlist-menu-level-2"
                v-show="openedMenuItems[`s${sport.id}`]"
                v-if="!onlySport">
                <li v-if="showSportPageFixture">
                  <span
                    class="bto-sb-sportlist-menu-item"
                    :key="sport.id"
                    @click="selectSport(sport)">
                    <span
                      v-show="showSportIcon"
                      class="bto-sb-flag bto-sb-flag-oval"
                      :class="sport.class"></span>
                    <span class="bto-sb-sportlist-menu-category-name">
                      {{ t("FT.SportEvents").replace("{sportName}", sport.name) }}
                    </span>
                    <span
                      class="bto-sb-sportlist-menu-category-events"
                      v-if="showOutrights === true">
                      {{ sport.numberOfItems }}
                    </span>
                    <span class="bto-sb-sportlist-menu-category-events" v-else v-show="showNumbers">
                      {{ sport.numberOfMarkets }}
                    </span>
                  </span>
                </li>
                <li v-for="category in sport.items" v-bind:key="category.id">
                  <span
                    class="bto-sb-sportlist-menu-item"
                    @click="toggleMenu(`c${category.id}`, sport)">
                    <span
                      class="bto-sb-flag bto-sb-flag-oval"
                      v-show="showSportIcon"
                      :class="category.class || 'group'"></span>
                    <span class="bto-sb-sportlist-menu-category-name">{{ category.name }}</span>
                    <ToggleFavoriteComponent
                      v-if="showFavorites"
                      :favType="2"
                      :sport="sport"
                      :category="category" />
                    <span class="bto-sb-sportlist-menu-category-events" v-show="showNumbers">{{
                      category.numberOfItems
                    }}</span>
                  </span>
                  <ul
                    class="bto-sb-sportlist-menu-level-3"
                    :class="{ 'bto-sb-sportlist-menu-group': category.cType === 2 }"
                    v-show="openedMenuItems[`c${category.id}`]">
                    <li
                      v-for="tournament in category.items"
                      v-bind:key="tournament.id"
                      @mousemove="showTooltip($event, category, tournament)"
                      @mouseleave="hideTooltip"
                      :class="{
                        'bto-sb-sportlist-menu-item-active': selectedTournaments.find(
                          (t) => t == getTournamentId(tournament, sport.class)
                        ),
                      }">
                      <a
                        @click="toggleTournament(getTournamentId(tournament, sport.class))"
                        class="bto-sb-sportlist-menu-item"
                        :class="{
                          'bto-sb-sportlist-menu-item-cash':
                            cashOutVisibility && tournament.cashOutVisibility,
                        }">
                        <span class="bto-sb-sportlist-menu-tournament-select-box">
                          <label class="bto-sb-form-control bto-sb-form-control-checkbox">
                            <input
                              type="checkbox"
                              v-show="showCheckbox"
                              :checked="
                                selectedTournaments.find(
                                  (t) => t == getTournamentId(tournament, sport.class)
                                )
                              "
                              @click.prevent="
                                toggleTournament(getTournamentId(tournament, sport.class))
                              " />
                            <span
                              class="bto-sb-form-control-indicator"
                              v-show="showCheckbox"></span>
                          </label>
                        </span>
                        <span
                          v-if="category.cType === 2"
                          class="bto-sb-flag bto-sb-flag-oval"
                          :class="tournament.class"></span>
                        <span class="bto-sb-sportlist-menu-tournament-name">
                          {{ tournament.name }}
                        </span>
                        <span
                          class="bto-sb-sportlist-menu-tournament-cash"
                          v-if="cashOutVisibility && tournament.cashOutVisibility"
                          ><i class="bto-app-cash"></i>
                        </span>
                        <ToggleFavoriteComponent
                          v-if="showFavorites"
                          :favType="3"
                          :sport="sport"
                          :tournament="tournament" />
                        <span class="bto-sb-sportlist-menu-tournament-events" v-show="showNumbers">
                          {{ tournament.numberOfItems }}
                        </span>
                      </a>
                    </li>
                    <li
                      :class="{
                        'bto-sb-sportlist-menu-item-active': selectedTournaments.find(
                          (c) => c === `c${category.id}`
                        ),
                      }"
                      v-if="
                        category.numberOfOutrights &&
                        sport.id !== horseRacingSportId &&
                        sport.id !== greyhoundRacingSportId
                      ">
                      <span class="bto-sb-sportlist-menu-tournament-select-box">
                        <label class="bto-sb-form-control bto-sb-form-control-checkbox">
                          <input
                            type="checkbox"
                            v-show="showCheckbox"
                            :checked="selectedTournaments.find((c) => c === `c${category.id}`)"
                            @click="toggleCategoryOutrights(category.id)" />
                          <span class="bto-sb-form-control-indicator" v-show="showCheckbox"></span>
                        </label>
                      </span>
                      <a
                        @click="toggleCategoryOutrights(category.id)"
                        class="bto-sb-sportlist-menu-item">
                        <span class="bto-sb-sportlist-menu-tournament-name">{{
                          t("Mobile.Outrights")
                        }}</span>
                        <span class="bto-sb-sportlist-menu-tournament-events" v-show="true">
                          {{ category.numberOfOutrights }}</span
                        >
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import store from '../../../store';
  import FixtureMenuService from './service-fixture-menu';
  import RangeSliderComponent from '../../common/range-slider-component';
  import { EventBus } from '../../../services/event-bus-service';
  import { urlFriendlyParam } from '@bto-services/utils';
  import ToggleFavoriteComponent from '../../common/toggle-favorite-component';

  export default {
    name: 'FixtureMenuWidget',
    data() {
      return {
        selectedTournaments: [],
        fixtureMenuData: {},
        openedMenuItems: [],
        tplString: '',
        routeChangeCausedByFixtureMenu: false,
        fixtureTimeFilter: 'all',
        selectedSport: 0,
        selectedSeoSport: 0,
        toggleSelectedSport: false,
        spInfo: {},
        isUS: APP_SETTINGS.settings.layout === 'US',
      };
    },
    props: {
      showSportIcon: {
        type: Boolean,
        default: true,
        label: 'Show Sport Icon',
      },
      showSportPageFixture: {
        type: Boolean,
        default: true,
        label: 'Show Sport Page Fixture',
      },
      showCheckbox: {
        type: Boolean,
        default: true,
        label: 'Show Checkbox',
      },
      showNumbers: {
        type: Boolean,
        default: true,
        label: 'Show Numbers',
      },
      showOutrights: {
        type: Boolean,
        default: true,
        label: 'Show Outrights',
      },
      onlySport: {
        type: Boolean,
        default: false,
        label: 'Show only sports in fixture menu',
      },
      showFavorites: {
        type: Boolean,
        default: true,
        label: 'Show favorite icons on sport, tournaments and categories',
      },
      maxTournaments: {
        type: String,
        default: '5',
        label: 'Max tournaments to open',
      },
    },
    created() {
      this.updateRouteData();
      this.getFixtureMenuData();

      EventBus.$on('closeTournamentTab', this.toggleTournament);

      EventBus.$on('closeOutrightsTab', this.toggleCategoryOutrights);
    },
    mounted() {
      EventBus.$on('leftColToggle', this.handleLeftColToggle);
    },
    destroyed() {
      EventBus.$off('leftColToggle', this.handleLeftColToggle);
      EventBus.$off('closeTournamentTab', this.toggleTournament);
      EventBus.$off('closeOutrightsTab', this.toggleCategoryOutrights);
    },
    watch: {
      $route() {
        if (!this.routeChangeCausedByFixtureMenu) {
          this.updateRouteData();
        } else {
          this.routeChangeCausedByFixtureMenu = false;
        }
      },
    },
    computed: {
      horseRacingSportId() {
        return store.state.SportsModule.hrSportId;
      },
      greyhoundRacingSportId() {
        return store.state.SportsModule.ghSportId;
      },
      leftColExpanded() {
        return store.state.LayoutModule.leftColExpanded;
      },
      /**
       * cash out visibility on tournament level
       */
      cashoutEnabledUser() {
        return store.state.playerInfoModule.playerInfo.cashout;
      },
      cashOutVisibility() {
        return this.cashoutEnabledDB &&
          (!APP_SETTINGS.player.token || this.cashoutEnabledUser);
      },
      sortByFavoriteSports() {
        const favoriteSports = this.$store.state.favoritesModule.sports;
        const fixtureMenu = Object.values(this.fixtureMenuData) || [];
        const favoriteIds = new Set(favoriteSports.map(item => item.sportId));
        if (fixtureMenu.length > 0 && favoriteSports.length > 0) {
          const favorites = fixtureMenu.filter(item => favoriteIds.has(item.id));
          favorites.sort((a, b) => {
            const indexA = favoriteSports.findIndex(sport => sport.sportId === a.id);
            const indexB = favoriteSports.findIndex(sport => sport.sportId === b.id);
            return indexA - indexB;
          });
          const nonFavorites = fixtureMenu.filter(item => !favoriteIds.has(item.id));
          return [...favorites, ...nonFavorites];
        }
        return fixtureMenu;
      },
      cashoutEnabledDB() {
        return store.getters.getCashoutDbSetting;
      },
    },
    methods: {
      isSportActive(sport) {
        if (this.onlySport) {
          return this.selectedSeoSport === sport.id;
        }
        return this.openedMenuItems[`s${sport.id}`];
      },
      handleLeftColToggle(expanded) {
        if (expanded) {
          if (typeof this.$refs.fmenu !== 'undefined') {
            Vue.prototype.$vuebar.destroyScrollbar(this.$refs.fmenu, { clearStyles: true });
            this.$refs.fmenu.firstElementChild.removeAttribute("style");
          }
        } else {
          this.$nextTick(() => {
            setTimeout(() => {
              if (typeof this.$refs.fmenu !== 'undefined') {
                this.$refs.fmenu.style.height = `${400}px`;
                if (!Vue.prototype.$vuebar.getState(this.$refs.fmenu)) {
                  Vue.prototype.$vuebar.initScrollbar(this.$refs.fmenu, {});
                }
              }
            }, 0);
          });
        }
      },
      // Get all data from sportId and Link to sport pages from fixture tree
      selectSport(sport) {
        this.routeChangeCausedByFixtureMenu = false;
        if (this.selectedSeoSport === sport.id) {
          if (!this.onlySport) {
            this.selectedSeoSport === 0;
            this.$router.push({ name: 'home' });
          }
          return;
        }
        const routeParams = {
          sportName: urlFriendlyParam(sport.name),
          sportId: sport.id,
        };
        this.$router.push({ name: 'seoSport', params: routeParams });
      },
      /**
       *
       */
      updateRouteData() {
        // check route params for previously selected tournaments
        let routeParams = this.$route.params;
        // when redirecting from mobile to check for seoTournamentGroup if that is present to add tg to the fixtureIds so it could be selected in the fixture menu
        let fixId = this.$route.name === 'seoTournamentGroup' ? `tg${routeParams.fixtureIds}` : routeParams.fixtureIds;
        this.selectedSport = +routeParams.sportId || 0;

        this.selectedSeoSport = +routeParams.sportId || 0;

        if (typeof fixId !== 'undefined' && fixId !== '-') {
          this.selectedTournaments = fixId.split(',');
        } else {
          this.selectedTournaments = [];
        }
      },
      /**
       * getFixtureMenuData API call to get data for the fixture menu
       */
      getFixtureMenuData() {
        // get uri params
        let routeParams = this.$route.params;

        // get fixture menu data from API
        let request = new FixtureMenuService(routeParams.fixtureDateFilter || 'all');
        request.execute((resp) => {
          // update all sports from fixture menu api results
          let catMap = {};
          const allFixtures = request.fillDate(resp.data.s, catMap);
          store.commit('updateAllSportsList', allFixtures);
          store.commit('updateSelectedSport', parseInt(routeParams.sportId, 10));
          store.commit('setCategoryMap', catMap);
          this.fixtureMenuData = Object.assign({}, allFixtures);
          if (routeParams.fixtureIds) {
            let allIds = routeParams.fixtureIds.split(',') || [];

            let selectedTournamentIds = allIds.filter(id => !id.startsWith('c'));
            let selectedCategoryOutrightsIds = allIds.filter(id => id.startsWith('c'));

            Object.values(this.fixtureMenuData).forEach(sport => {
              sport.items.forEach(category => {
                if (selectedCategoryOutrightsIds.length) {
                  selectedCategoryOutrightsIds.forEach((selectedCategoryOutrightsId) => {
                    if (selectedCategoryOutrightsId == `c${category.id}`) {
                      this.openedMenuItems[`s${sport.id}`] = true;
                      this.openedMenuItems[`c${category.id}`] = true;
                    }
                  });
                }

                if (selectedTournamentIds.length) {
                  category.items.forEach(tournament => {
                    selectedTournamentIds.forEach((selectedTournamentId) => {
                      if (selectedTournamentId == tournament.id) {
                        this.openedMenuItems[`s${sport.id}`] = true;
                        this.openedMenuItems[`c${category.id}`] = true;
                      }
                    });
                  });
                }
              });
            });
          }
        }, () => {
        });
      },
      /**
       * toggleMenu opens/closes sport or category menu
       * @param key
       * @param sport
       */
      toggleMenu(key, sport) {
        this.spInfo[sport.id] = sport.items.map((cat) => `c${cat.id}`);
        this.openedMenuItems[key] = !this.openedMenuItems[key];
        this.openedMenuItems = Object.assign({}, this.openedMenuItems);
      },
      /**
       * Store data in window dataLayer for GTM
      */
      sportSelectionGTM(name) {
        window.dataLayer.push({
          event: 'sport_selected',
          sport_name: name,
          PID: APP_SETTINGS.player.id,
        });
      },
      /**
       *
       */
      maxSelectedLimitReached() {
        return this.selectedTournaments.filter(t => !String(t).startsWith('x-')).length >= parseFloat(this.maxTournaments);
      },
      getTournamentId(tournament, sportClass) {
        if (sportClass && sportClass === 'horse-racing') {
          return `hr${tournament.id}`;
        } else if (sportClass && sportClass === 'greyhound') {
          return `gh${tournament.id}`;
        }
        return tournament.cType === 4 ? `tg${tournament.id}` : tournament.id;
      },
      cutFirst() {
        if (String(this.selectedTournaments[0]).startsWith('x-')) {
          this.selectedTournaments.splice(0, 2);
        } else {
          this.selectedTournaments.splice(0, 1);
        }
      },
      /**
       * toggleTournament selects/unselects only one tournament
       * @param tournamentId
       */
      toggleTournament(tournamentId) {
        let tournamentIndex = this.selectedTournaments.findIndex(t => t == tournamentId || t == `tg${tournamentId}`);
        // add/remove id in the selectedTournaments list
        if (tournamentIndex === -1) {
          // check if player can select more tournaments
          if (this.maxSelectedLimitReached()) {
            // remove first selection when limit reached  FIFO
            this.cutFirst();
          }
          this.selectedTournaments.push(tournamentId);
        } else {
          this.selectedTournaments.splice(tournamentIndex, 1);
        }
        this.changeRoute();
      },
      /**
       *
       */
      toggleCategoryOutrights(categoryId) {
        let categoryIndex = this.selectedTournaments.findIndex(c => String(c).startsWith('c'));
        let same = categoryIndex !== -1 ? this.selectedTournaments[categoryIndex].substring(1) == categoryId : false;

        if (categoryIndex !== -1) {
          this.selectedTournaments.splice(categoryIndex, 1);
          this.selectedTournaments = this.selectedTournaments.filter(t => !String(t).startsWith('x-'));
        }

        if (same) {
          this.changeRoute();
          return;
        }

        if (this.maxSelectedLimitReached()) {
          // remove first selection when limit reached FIFO
          this.cutFirst();
        }

        let categoryTournaments = [];
        const sports = Object.values(this.fixtureMenuData);

        for (let i = 0; i < sports.length; i++) {
          for (let j = 0; j < sports[i].items.length; j++) {
            if (sports[i].items[j].id == categoryId) {
              categoryTournaments = sports[i].items[j].items.map(t => {
                let isGroup = t.cType === 4;
                return isGroup ? `x-tg${t.id}` : `x-${t.id}`;
              });
              break;
            }
          }
          if (categoryTournaments.length) {
            break;
          }
        }

        this.selectedTournaments.push(categoryTournaments);
        this.selectedTournaments.push(`c${categoryId}`);

        this.changeRoute();
      },
      /**
       * changeRoute is publishing fixture menu selection changes in the URIcd sb-front
       */
      changeRoute() {
        // get uri params
        let routeParams = this.$route.params;
        this.selectedSport = 0;

        // convert selected tournaments in comma separated ids
        routeParams.fixtureIds = this.selectedTournaments.join(',') || '-';
        if (routeParams.fixtureIds === '-') {
          this.$router.push({ name: 'home' });
          return;
        }

        // routeParams.fixtureDateFilter = '';
        // if (routeParams.fixtureDateFilter === '') {
        routeParams.fixtureDateFilter = this.fixtureTimeFilter;
        // }

        this.routeChangeCausedByFixtureMenu = true;

        // push route change
        this.$router.push({ name: 'sports', params: routeParams });
      },

      /**
       * onDateSliderChange event lister broadcasted from date slider
       * @param value - selected date period
       */
      onDateSliderChange(value) {
        let dateRange;
        switch (value) {
          case 'Public.Today':
            dateRange = '1-day';
            break;
          case 'SportMenu.24Filter':
            dateRange = '24-hour';
            break;
          case 'SportMenu.3DaysFilter':
            dateRange = '3-days';
            break;
          case 'Public.Week':
            dateRange = '7-days';
            break;
          case 'Mobile.all':
            dateRange = 'all';
            break;
          default:
            console.error('range slider returned invalid value'); //eslint-disable-line
            return;
        }
        // get uri params
        let routeParams = this.$route.params;
        routeParams.fixtureDateFilter = dateRange;
        this.fixtureTimeFilter = dateRange;
        // push route change
        // this.$router.push({ name: 'home', params: routeParams }); // home route has NO fixtureDateFilter parameter
        // get fixture menu data for the new selected date filter value
        this.getFixtureMenuData();
      },
      showTooltip(event, category, tournament) {
        if (category.cType === 2) {
          EventBus.$emit('showoddmarketpopup', {
            message: tournament.parentName,
            e: event
          });
        }
      },
      hideTooltip() {
        EventBus.$emit('hideoddmarketpopup');
      }
    },
    components: {
      RangeSliderComponent,
      ToggleFavoriteComponent
    },
  };
</script>
